import React from 'react';
import { createSlice } from '@reduxjs/toolkit'

import { 
  setNameFilter, 
  setComplianceFilter, 
  setHvaStatusFilter, 
  setLocation, 
  setArchived 
} from './filtersSlice';

const initialMiscState = {
  data: {
    courseCount: 0,
    renderedPages: 1,
    requestedPages: 2,
  },
};

// Note: state.variable = value is not state mutation in this case, createSlice has integrated immer that handles this correctly

const miscSlice = createSlice({
  name: 'miscData',
  initialState: initialMiscState,
  reducers: {
    setCourseCount: (state, action) => {
      state.data.courseCount = action.payload;
    },
    setMiscData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    setPage: (state, action) => {
      state.data.renderedPages = action.payload;
      state.data.requestedPages = action.payload + 1;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => 
        [
          setNameFilter.type, 
          setComplianceFilter.type, 
          setHvaStatusFilter.type, 
          setLocation.type, 
          setArchived.type
        ].includes(action.type),
      (state) => {
        state.data.renderedPages = 1;
        state.data.requestedPages = 2;
      }
    );
  } // This code makes this reducer listen for action triggered in the filters reducer
});

export const { setMiscData, setCourseCount, setPage } = miscSlice.actions;
export const miscDataReducer = miscSlice.reducer;